import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DeepDiveComponent} from './deep-dive.component';
import {DxDataGridModule, DxChartModule, DxDropDownButtonModule, DxPopupModule, DxTextBoxModule, DxDateBoxModule, DxSwitchModule, DxNumberBoxModule, DxSelectBoxModule, DxButtonModule, DxLoadPanelModule, DxScrollViewModule} from 'devextreme-angular';
import {BookmarkModule} from 'src/app/widgets/bookmark/bookmark.module';
import {InfoHeaderModule} from 'src/app/widgets/info-header/info-header.module';
import {JumpToModule} from 'src/app/widgets/jump-to/jump-to.module';
import {TaskListPopupModule} from '../../task/task-list-popup/task-list-popup.module';
import {TaskPopupModule} from '../../task/task-popup/task-popup.module';
import {SimulateMultiPopupModule} from '../simulate-multi-popup/simulate-multi-popup.module';
import {DeepDiveRoutingModule} from './deep-dive-routing.module';
import {DirectivesModule} from 'src/app/directives/directives/directives.module';
import { AutocompleteComponent } from 'src/app/widgets';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { BookmarkNewComponent } from "../../../widgets/bookmark-new/bookmark-new.component";



@NgModule({
	declarations: [
		DeepDiveComponent
	],
	imports: [
    CommonModule,
    DxTableControllerDirective,
    DeepDiveRoutingModule,
    DirectivesModule,
    JumpToModule,
    TaskPopupModule,
    TaskListPopupModule,
    SimulateMultiPopupModule,
    InfoHeaderModule,
    AutocompleteComponent,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxDataGridModule,
    DxChartModule,
    DxDropDownButtonModule,
    DxPopupModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxSwitchModule,
    DxButtonModule,
    DxScrollViewModule,
    BookmarkNewComponent
]
})
export class DeepDiveModule {}
